export enum EntityGroupTableFilterTypes {
  Status = "status",
}
